import apiCall from "../../api/crentAPI";
import store from "@/store";
const ENV =
  process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "development"
    ? "ORM_" + process.env.VUE_APP_CUSTOMER_NAME + "_"
    : "ORM_";
import {
  formateDatetime,
  formatHour,
  concatDateTimeZone,
} from "@/constants/formater";

// import slugify from "slugify";

const state = () => ({
  cargroup: [],
  aboCargroup: [],
  groupimages: {},
  selectedStationGroupfilter: [],
  globalGroupfilter: [],
});
const getters = {
  GET_GLOBAL_CARGROUPS: (state) => state.cargroup || null,
  GET_ABO_CARGROUPS: (state) => state.aboCargroup || null,
  GET_CARGROUP_BY_ID: (state) => async (carID) => {
    const group =
        state.selectedStationCargroup ||
      JSON.parse(localStorage.getItem(ENV + "selectedStationCargroup")) ||
      (await store.dispatch("cargroup/GET_CARGROUP_FROM_STATION"));
    return group.find((car) => car.id === carID);
  },
  GET_GLOBAL_CARGROUPS_IMAGES: (state) =>
    JSON.parse(JSON.stringify(state.groupimages)) || null,
  GET_GLOBAL_CARGROUPS_IMAGE: (state) => async (carID) => {
    if (state.groupimages[carID]) {
      return state.groupimages[carID];
    }
    const group = await store.getters["cargroup/GET_CARGROUP_BY_ID"](carID);
    return group?.images || null;
  },
  GET_GROUPFILTER: (state) =>
    JSON.parse(JSON.stringify(state.selectedStationGroupfilter)) || null,
  GET_GLOBAL_GROUPFILTER: (state) => state.globalGroupfilter,
  GET_GROUPS_FROM_SELECTEDSTATION: (state) =>
    state.selectedStationCargroup ||
    JSON.parse(localStorage.getItem(ENV + "selectedStationCargroup")),
};
const actions = {
  // eslint-disable-next-line
  async SET_CARGROUPS_ALL({ state, dispatch, commit }, isAbo = false) {
    const payload = {
      abo_groups: isAbo
    };

    if (!isAbo && state.cargroup.length > 0) {
      const groups = state.cargroup;
      const groupFilter = [];
      for (const key in groups) {
        if (Object.hasOwnProperty.call(groups, key)) {
          groups[key].vehicle_category.forEach((element) => {
            const vehicleCategory = element.id;
            if (
              groupFilter.find((group) => group == vehicleCategory) == undefined
            ) {
              groupFilter.push(vehicleCategory);
            }
          });
        }
      }
      commit("MUTATE_GROUPFILTER_GLOBAL", groupFilter);
      groups.forEach((element) => {
        element.price = null;
      });
      await commit("MUTATE_CARGROUPS", groups);
      return true;
    }

    if (isAbo && state.aboCargroup && state.aboCargroup.length > 0) {
      return true;
    }

    let object = [];
    await apiCall.get("/api/rent/groups", payload, (groups) => {
      const groupFilter = [];
      for (const key in groups) {
        if (Object.hasOwnProperty.call(groups, key)) {
          groups[key].vehicle_category.forEach((element) => {
            const vehicleCategory = element.id;
            if (
              groupFilter.find((group) => group == vehicleCategory) == undefined
            ) {
              groupFilter.push(vehicleCategory);
            }
          });
        }
      }
      commit("MUTATE_GROUPFILTER_GLOBAL", groupFilter);
      object = groups;
      object.forEach((element) => {
        element.price = null;
      });
    });

    if (isAbo) {
      commit("MUTATE_ABO_CARGROUPS", object);
    } else {
      commit("MUTATE_CARGROUPS", object);
    }

    return true;
  },
  async SET_CARGROUP_IMAGE({ state, commit }, id) {
    const payload = "";

    if (state.groupimages[id]) {
      return state.groupimages[id];
    }
    let image = null;
    await apiCall.get(
      "/api/rent/groups/" + id + "/images",
      payload,
      (result) => {
        const data = JSON.stringify(result);
        image = data;
        commit("MUTATE_GROUP_IMAGE", { id: id, result: result });
      }
    );

    return JSON.parse(image);
  },
  async GET_CARGROUP_FROM_STATION({ commit }) {
    const startstation = await store.getters["userSession/GET_STATION"];
    const endstation = await store.getters["userSession/GET_STATION_END"];
    const date = await store.getters["userSession/GET_RESERVATIONDATE"];
    const time = await store.getters["userSession/GET_RESERVATIONTIME"];
    const StartEndDT = concatDateTimeZone(date, time);
    let offer_rate = null;
    if (
      store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE") == "J" &&
      process.env.VUE_APP_OFFERS == "true"
    ) {
      const selectedOffer = await store.getters["offers/GET_OFFERSELECTED"];
      if (Object.keys(selectedOffer).length > 0) {
        offer_rate = selectedOffer.rate_code;
      }
    }

    // eslint-disable-next-line
    const payload = {
      station_id: startstation,
      planned_endstation_id: endstation,
      startdate: StartEndDT[0],
      planned_enddate: StartEndDT[1],
      offer_rate,
    };

    let groups = Object;

    //  + station // soon station ...
    await apiCall.get("/api/rent/groups", payload, (result) => {
      // console.log("GROUPFILTER", result);
      if (result == "error") return;
      const groupFilter = [];
      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          result[key].vehicle_category.forEach((element) => {
            const vehicleCategory = element.id;
            if (
              groupFilter.find((group) => group == vehicleCategory) == undefined
            ) {
              groupFilter.push(vehicleCategory);
            }
          });
        }
      }
      commit("MUTATE_GROUPS_FROM_STATION", result);
      commit("MUTATE_GROUPFILTER_FROM_STATION", groupFilter.sort());
      groups = result;
    });
    return groups;
  },
  // eslint-disable-next-line
  async GET_VEHICLES({ commit }) {
    let groups = Object;
    const showAllStations = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_ABO_ALL_STAT"
    );
    let startstation = await store.getters["userSession/GET_STATION"];
    const vehicle_group_id = '%'; //await store.getters["userSession/GET_CARGROUP"];

    if (showAllStations == 1 || showAllStations == "1") {
      startstation = "%";
    }

    const date = await store.getters["userSession/GET_RESERVATIONDATE"];
    const time = await store.getters["userSession/GET_RESERVATIONTIME"];
    const StartEndDT = concatDateTimeZone(date, time);

    const payload = {
      station_id: startstation,
      branch: await store.getters["userSession/GET_BRANCH"],
      startdate: StartEndDT[0],
      enddate: StartEndDT[1],
    };

    await apiCall.get("/api/rent/vehicles", payload, (result) => {
      // console.log("GROUPFILTER", result);
      if (result == "error") return;
      const groupFilter = [];
      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const vehicleCategory = result[key].vehicle_category;
          if (
            groupFilter.find((group) => group == vehicleCategory) == undefined
          ) {
            groupFilter.push(vehicleCategory);
          }
        }
      }
      commit("MUTATE_GROUPFILTER_FROM_STATION", groupFilter.sort());
      groups = result;
    });
    return groups;
  },
  async GET_VEHICLES_V2({ commit }, filter) {

    console.log(filter)

    let groups = Object;
    const showAllStations = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_ABO_ALL_STAT"
    );
    let startstation = await store.getters["userSession/GET_STATION"];


    if (showAllStations == 1 || showAllStations == "1") {
      startstation = "%";
    }

    const date = await store.getters["userSession/GET_RESERVATIONDATE"];
    const time = await store.getters["userSession/GET_RESERVATIONTIME"];
    const StartEndDT = concatDateTimeZone(date, time);

    const payload = {
      station_id: startstation,
      startdate: StartEndDT[0],
      enddate: StartEndDT[1],
      vehicle_group_id: filter.vehicle_group_id?.join(',') || "",
      manufacturer: filter.manufacturer?.join(',') || "",
      models: filter.models?.join(',') || "",
      durations: filter.durations?.join(',') || "",
      fuel_types: filter.fuel_types?.join(',') || "",
      vehicle_types: filter.vehicle_types?.join(',') || "",
      colors: filter.colors?.join(',') || "",
      availabilities: filter.availabilities?.join(',') || "",
      equipments: filter.equipments?.join(',') || "",
      gears: filter.gears?.join(',') || "",
      top: filter.top || false,
      super_top: filter.super_top || false,
      page: filter.page || 1
    };

    await apiCall.get("/api/rent/v2/vehicles", payload, (result) => {
      // console.log("GROUPFILTER", result);
      if (result == "error") return;
      const groupFilter = [];
      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const vehicleCategory = result[key].vehicle_category;
          if (
            groupFilter.find((group) => group == vehicleCategory) == undefined
          ) {
            groupFilter.push(vehicleCategory);
          }
        }
      }
      commit("MUTATE_GROUPFILTER_FROM_STATION", groupFilter.sort());
      groups = result;
    });
    return groups;
  },
  // eslint-disable-next-line
  async GET_VEHICLE_BY_ID({ commit }, vehicle) {
    let groups = Object;
    const startstation = await store.getters["userSession/GET_STATION"];
    const date = await store.getters["userSession/GET_RESERVATIONDATE"];
    const time = await store.getters["userSession/GET_RESERVATIONTIME"];
    const StartEndDT = concatDateTimeZone(date, time);
    const endArray = [];

    vehicle.prices.forEach((element) => {
      const newDate = new Date(date.start + "T" + time.start);
      // console.log("date.start", newDate);
      const selectedAbo = element.months;
      // console.log("selectedAbo", selectedAbo);

      endArray.push(
        formateDatetime(newDate.setMonth(newDate.getMonth() + selectedAbo))
      );
      // console.log("endArray", endArray);
    });

    const payload = {
      station_id: startstation,
      branch: await store.getters["userSession/GET_BRANCH"],
      startdate: StartEndDT[0],
      enddate: endArray.join(";"),
      vehicle_id: vehicle.id,
    };

    await apiCall.get("/api/rent/vehicles/" + vehicle.id, payload, (result) => {
      // console.log("GROUPFILTER", result);
      if (result == "error") return;
      groups = result;
    });
    // console.log(groups);
    return groups;
  },
  // eslint-disable-next-line
  async GET_MANUFACTURERS({ commit }) {
    const manufacturers = [];
    const payload = {};
    await apiCall.get("/api/rent/vehicles/manufacturers", payload, (result) => {
      // console.log("GROUPFILTER", result);
      if (result == "error") return;
      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const manufacturer = result[key].name;
          manufacturers.push(manufacturer);
        }
      }
    });
    return manufacturers;
  },
  // eslint-disable-next-line
  async GET_COLORS({ commit }) {
    const colors = [];
    const payload = {};

    await apiCall.get("/api/rent/vehicle-colors", payload, (result) => {
      if (result == "error") return;

      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const color = result[key].color;
          colors.push(color);
        }
      }
    });
    return colors;
  },
  // eslint-disable-next-line
  async GET_AUTO_ABO_FILTER({ commit }, vehicleGroupId) {
    const manufacturers = [];
    const models = [];
    const durations = [];
    const fuelTypes = [];
    const vehicleTypes = [];
    const colors = [];
    const availabilities = [];
    const gears = [];
    const payload = {
      'vehicle_group_id': [vehicleGroupId].join(',')
    };

    await apiCall.get("/api/rent/vehicle-filter-options", payload, (result) => {
      if (result == "error") return;

    const colorsInResult = result.colors;
    const manufacturersInResult = result.manufacturers;
    const modelsInResult = result.models;
    const fuelTypesInResult = result.fuelTypes;
    const vehicleTypesInResult = result.vehicleTypes;
    const availabilitiesInResult = result.availabilities;
    const gearsInResult = result.gears;
    const durationsInResult = result.durations;

      for (const key in colorsInResult) {
        const color = colorsInResult[key];
        colors.push(color);
      }

      for (const key in manufacturersInResult) {
        const manufacturer = manufacturersInResult[key];
        manufacturers.push(manufacturer);
      }

      for (const key in durationsInResult) {
        const duration = durationsInResult[key];
        durations.push(duration);
      }

      for (const key in modelsInResult) {
        const model = modelsInResult[key];
        models.push(model);
      }

      for (const key in fuelTypesInResult) {
        const fuelType = fuelTypesInResult[key];
        fuelTypes.push(fuelType);
      }

      for (const key in vehicleTypesInResult) {
        const vehicleType = vehicleTypesInResult[key];
        vehicleTypes.push(vehicleType);
      }

      for (const key in availabilitiesInResult) {
        const availability = availabilitiesInResult[key];
        availabilities.push(availability);
      }

      for (const key in gearsInResult) {
        const gear = gearsInResult[key];
        gears.push(gear);
      }
    });
    return {
      colors: colors,
      manufacturers: manufacturers,
      models: models,
      fuelTypes: fuelTypes,
      vehicleTypes: vehicleTypes,
      availabilities: availabilities,
      gears: gears,
      durations: durations
    };
  },
  // eslint-disable-next-line
  async GET_SUBSCRIPTIONEQUIPMENTS({ commit }) {
    const subscriptionEquipments = [];
    const payload = {};

    await apiCall.get(
      "/api/rent/vehicles/subscription-equipments",
      payload,
      (result) => {
        if (result == "error") return;

        for (const key in result) {
          if (Object.hasOwnProperty.call(result, key)) {
            const subscriptionEquipment = result[key].description;
            subscriptionEquipments.push(subscriptionEquipment);
          }
        }
      }
    );
    return subscriptionEquipments;
  },
  // eslint-disable-next-line
  async SET_AVAILABILITIES({ commit }, groupKey) {
    const date = await store.getters["userSession/GET_RESERVATIONDATE"];
    const time = await store.getters["userSession/GET_RESERVATIONTIME"];
    const startstation = await store.getters["userSession/GET_STATION"];

    let startTimeDate = "";
    let endTimeDate = "";
    let st = "";
    const timeNow = formatHour(new Date());

    if (date.start) {
      if (time.start) {
        st = time.start + ":00";
      } else {
        st = timeNow + ":00";
      }
      startTimeDate = date.start + "T" + st;
    } else {
      startTimeDate = formateDatetime(Date.now());
    }
    if (date.end) {
      // console.log('time', time.end);
      if (time.end) {
        st = time.end + ":00";
      } else {
        st = timeNow + ":00";
      }
      endTimeDate = date.end + "T" + st;
    } else {
      endTimeDate = formateDatetime(Date.now());
    }
    const payload = {
      // eslint-disable-next-line
      startstation_id: startstation,
      // eslint-disable-next-line
      planned_group_id: groupKey,
      // eslint-disable-next-line
      startdate: startTimeDate,
      // eslint-disable-next-line
      planned_enddate: endTimeDate,
    };
    // eslint-disable-next-line
    let result = Object;
    await apiCall.get("/api/rent/groups/availabilities", payload, (group) => {
      result = group;
    });
    return result;
  },
  SET_GROUPIMAGES({ commit }, images) {
    commit("MUTATE_SESSION_GROUPIMAGES", images);
  },
  async GET_EQUIPMENT() {
    let result = Object;
    await apiCall.get("/api/rent/groups/features", "", (group) => {
      result = group;
    });
    const filtered = [];

    if (result.length > 0) {
      result.forEach((result) => {
        filtered.push(result.feature_name);
      });
    }

    // console.log("result", result);
    return filtered;
  },
};

// mutations
const mutations = {
  MUTATE_CARGROUPS(state, groups) {
    state.cargroup = groups;
    localStorage.setItem(ENV + "groups", JSON.stringify(groups));
  },
  MUTATE_ABO_CARGROUPS(state, groups) {
    state.aboCargroup = groups;
    //localStorage.setItem(ENV + "aboGroups", JSON.stringify(groups));
  },
  MUTATE_SESSION_GROUPIMAGES(state, images) {
    state.groupimages = images;
  },
  MUTATE_GROUP_IMAGE(state, payload) {
    state.groupimages[payload.id] = payload.result;
    // sessionStorage.setItem(
    //   ENV + "groupimages",
    //   JSON.stringify(state.groupimages)
    // );
  },
  MUTATE_GROUPS_FROM_STATION(state, groups) {
    state.selectedStationCargroup = groups;
    localStorage.setItem(
      ENV + "selectedStationCargroup",
      JSON.stringify(groups)
    );
  },
  MUTATE_GROUPFILTER_FROM_STATION(state, groupfilter) {
    state.selectedStationGroupfilter = groupfilter;
  },
  MUTATE_GROUPFILTER_GLOBAL(state, groupfilter) {
    state.globalGroupfilter = groupfilter;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
